module.exports = __webpack_public_path__ + "img/best-western-logo.e259c160.png";